import { Injectable } from '@angular/core';
import { BlocklyHelper, BlocklyNesting } from '@shared/blockly/core/helper';
import { BlocklyHelpRegistryService } from './blockly-help-registry.service';
import { BlocklyParserService } from './blockly-parser.service';

export type { BlocklyNesting };

@Injectable({
  providedIn: 'root'
})
export class BlocklyHelperService extends BlocklyHelper {
  constructor(
    templateParser: BlocklyParserService,
    blockHelpRegistry: BlocklyHelpRegistryService
  ) {
    super(templateParser, blockHelpRegistry);
  }
}
